var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cloud",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.328,
    height: 20.328,
    viewBox: "0 0 20.328 20.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5776",
    "data-name": "Path 5776",
    d: "M12.45,16.984a4.712,4.712,0,0,1,4.013-4.647.726.726,0,1,1,.207,1.438,3.245,3.245,0,0,0,.477,6.454h7.318a.726.726,0,0,1,0,1.452H17.147A4.7,4.7,0,0,1,12.45,16.984Z",
    transform: "translate(-12.45 -4.83)",
    fill: "#da291c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5777",
    "data-name": "Path 5777",
    d: "M22.115,22.115a.726.726,0,0,1-1.027,0L9.662,10.689l0,0L2.213,3.239A.726.726,0,0,1,3.239,2.213L9.7,8.673a4.7,4.7,0,0,1,9.113.932,4.7,4.7,0,0,1,.681,8.862l2.622,2.622A.726.726,0,0,1,22.115,22.115ZM20.17,16.178a3.25,3.25,0,0,0-2.136-5.247.763.763,0,0,1-.635-.756,3.249,3.249,0,0,0-5.491-2.347A3.172,3.172,0,0,0,10.928,9.9l7.4,7.4A3.217,3.217,0,0,0,20.17,16.178Z",
    transform: "translate(-2 -2)",
    fill: "#da291c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon_cloud.adae6d457f7e4c718cfdccd3a558cb07.svg";
export { ForwardRef as ReactComponent };